var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditProfile',{on:{"save":_vm.save},model:{value:(_vm.payload),callback:function ($$v) {_vm.payload=$$v},expression:"payload"}})}
var staticRenderFns = []

export { render, staticRenderFns }